import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ChallengeMakerBoard from '../components/ChallengeMakerBoard'
import * as ChallengeMakerActions from '../actions/ChallengeMaker'

function mapStateToProps(state) {
  return {
    board: state.board,
    robot: state.robot,
    goals: state.goals,
    newChallenge: state.newChallenge,
    log: state.log
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  let actionBindings = bindActionCreators(ChallengeMakerActions, dispatch)
  return actionBindings
}

export default connect(mapStateToProps, mapDispatchToProps)(ChallengeMakerBoard)



// WEBPACK FOOTER //
// ./containers/ChallengeMakerContainer.js